export default __webpack_public_path__ + "b89eabc2adaf97b863096e31cc616994.png";